<template>
    <div class="select-tags">
        <div class="select-tags-c" v-for="(group, key) in options" :key="key">
            <span class="select-tags-label">{{ group[0].label }}:</span>
            <Tag
                v-for="(item, i) in group"
                :key="item.id"
                :name="item.id"
                closable
                @on-close="onTagClose(item, i, group)"
                >{{ item.text }}</Tag
            >
        </div>
    </div>
</template>

<script>
import { groupBy } from '_u/helper'

export default {
    name: 'SelectTags',
    props: {
        value: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            options: {},
        }
    },
    watch: {
        value: {
            handler(val) {
                this.options = this.parseValue(val)
            },
            immediate: true,
        },
    },
    methods: {
        onTagClose(item, i, group) {
            group.splice(i, 1)
            this.$emit(
                'input',
                Object.values(this.options).reduce(
                    (acc, v) => (acc.push(...v), acc),
                    []
                )
            )
            this.$emit('close', item, i, group)
        },
        parseValue(val) {
            return groupBy(val, (v) => v.key)
        },
    },
}
</script>

<style lang="less" scoped>
.select-tags {
    &-c {
        display: inline-block;
        margin-right: 10px;
    }
    &-label{
        vertical-align: -1px;
        margin-right: 8px;
    }
}
</style>
